import { Autocomplete, TextField, createFilterOptions } from "@mui/material"
import LoadingSpinner from "components/LoadingSpinner";
import NotificationProvider from "components/NotificationProvider";
import { useAddVendorMutation, useGetVendorsQuery } from "features/vendor/vendorSlice"
import { PricingListStyle } from "./style";
import { arrayToObject } from "utils/object-util";

export const VendorField = ({ value, onChange, required, label, multiple }) => {
    const classes = PricingListStyle()

    const filter = createFilterOptions();
    let { data: vendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();
    const [addVendor, { isLoading: isAdding }] = useAddVendorMutation();

    let sProvidersByName = arrayToObject(vendors, 'name');

    let vendor = vendors?.find(s => s.id === value);

    const onValueChange = async (newValue) => {
        if (!multiple ?
            ((newValue && newValue.inputValue) || typeof newValue === 'string') :
            ((!!newValue[newValue.length - 1].inputValue || typeof newValue[newValue.length - 1] === 'string') && !sProvidersByName[newValue[newValue.length - 1].inputValue])) {
            // Commenting out the logic for adding a new vendor
            /*
            let result = await addVendor({ name: multiple ? newValue[newValue.length-1].inputValue : newValue.inputValue });
            if (result && !result.error) {
                NotificationProvider.success("Vendor added successfully");
            } else {
                NotificationProvider.error("Something happened, try again or contact support");
            }
            onChange(multiple ? newValue.map(v => v.id).concat(result?.data).filter(c => c !== undefined) : result?.data);
            */
        } else {
            multiple ? onChange(newValue.map(v => v.id)) :
                onChange(newValue?.id);
        }
    }

    return <>
        <LoadingSpinner loading={isAdding || isLoadingVendors} />
        <Autocomplete
            multiple={multiple}
            value={vendor}
            onChange={(event, newValue) => { onValueChange(newValue) }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;
                // Commenting out the logic for suggesting the creation of a new value
                /*
                const isExisting = options.some((option) => inputValue === option.name);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        name: `Add "${inputValue}"`,
                    });
                }
                */
                return filtered;
            }}
            autoHighlight
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="vendor"
            options={vendors}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }
                // Commenting out the logic for dynamically created options
                /*
                if (option.inputValue) {
                    return option.inputValue;
                }
                */
                // Regular option
                return option.name;
            }}
            renderOption={(props, option) => <li {...props}> <div className={classes.options}>{option.name}</div></li>}
            freeSolo
            renderInput={(params) => (
                <TextField
                    value={vendor}
                    variant='outlined'
                    label={label}
                    InputLabelProps={{ className: classes.label }}
                    {...params}
                    inputProps={{
                        ...params.inputProps,
                        className: classes.input,
                        notchedOutline: classes.notchedOutline,
                    }}
                />
            )}
            className={classes.input}
        />
    </>

}